// Création de l'objet à envoyer au back
import { getArrayFilesToSend } from '../../../../../../utils/fileFunction';

const formaterFichiersPiecesIdentiteEtape1 = async (dataForm) => {
    return dataForm.piecesIdentite ? getArrayFilesToSend(dataForm.piecesIdentite) : null;
};

export default formaterFichiersPiecesIdentiteEtape1;
